import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

import { DashboardFilter } from '../../../../models/DashboardFilter';
import { CPPItemsFilter } from '../../../../models/CPP/CPPItemsFilter';

import { ToastrService } from 'ngx-toastr';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { CommonService } from './../../../../services/common/common.service';
import { CppService } from './../../../../services/cpp/cpp.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { Subscription, forkJoin } from 'rxjs';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { SraOrdersService } from '../../../../services/cpp/sra-orders.service';

@Component({
  selector: 'app-cppfilter',
  templateUrl: './cpp-filter.component.html',
  styleUrls: ['./cpp-filter.component.scss']
})

export class CPPFilterComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  selectedFilter: string;
  filterValueList: any[] = [];
  filterList: any[];
  headerYear: string;
  headerCompany: string;
  searchButtonClick = false;
  filter: CPPItemsFilter = new CPPItemsFilter();
  productFilters: any;
  searchValue = '';
  itemList: any = [];
  packagesizeMasterList: any = [];
  productLineMasterList: any = [];
  productCategoryMasterList: any = [];
  activeIngredientList: any = [];
  vendorList: any = [];
  disableFilterBtn = true;
  showOnlyFavorite = false;
  getCppItemNumbers: any;
  @Input()
  set filters(val: any[]) {
    this.filterList = val;
    if (val[0]) { this.selectedFilter = val[0].column; }
  }
  get filters(): any[] {
    return this.filterList;
  }

  @Input() isFromCOIPage: boolean;
  @Input() isFromCppPage: boolean;
  @Input() isFromSroPage: boolean;

  @Output()
  SearchFilter: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  ClearFilter: EventEmitter<any> = new EventEmitter<any>();
    constructor(public commonService: CommonService,
    public toastrService: ToastrService,
    private cppService: CppService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private localStorageService: LocalStorageService,
      private loaderService: LoaderService,
      private sroService: SraOrdersService
  ) {
  }

  updatedVal(e) {
    this.productFilters.Brand = e;
    this.validateProductSearch(this.productFilters.Brand);
  }

  validateBrand(e) {
    this.productFilters.Brand = e;
    if (e !== null && e !== '' && e.length > 1) {     
      this.disableFilterBtn = false;
    } else {
      this.disableFilterBtn = true;
    }
  }

  ngOnInit() {
    this.resetFilterInputValue();
    this.loaderService.setLoaderStatus(true);
    // get cpp Item Number List
    if (this.isFromCOIPage) {
      this.subscription.push(this.cppService.getCppItemNumberList(this.isFromCOIPage).subscribe((result: any[]) => {
        this.itemList = result;
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false) }));
    }
    else if (this.isFromSroPage)
    {
      this.subscription.push(this.sroService.getSroItemMasterDetails().subscribe((result) => {

        this.itemList = result.itemNumbers;
        this.activeIngredientList = result.activeIngrediants;
        this.vendorList = result.marketingBrand;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));
    }
    else {
      var isCppPage = false;
      if (this.isFromCppPage) {
        isCppPage = true;
      }

      this.subscription.push(this.cppService.getCppItemMasterDetails(isCppPage).subscribe((result) => {

        this.itemList = result.itemNumbers;
        this.activeIngredientList = result.activeIngrediants;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      if (this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST)) {
        this.vendorList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST));
      }
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_CPP_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_CPP_LIST));
    }

    // Product Catorgory master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST)) {
      this.productCategoryMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST));
    }

    this.searchButtonClick = false;
  }

  validateProductSearch(toValidateInput: any) {
    // To Validate Brand
    if ((toValidateInput !== null && toValidateInput !== '' && toValidateInput.toString().trim().length >= 2)
      || this.productFilters.Vendor !== null && this.productFilters.Vendor !== '' && this.productFilters.Vendor.toString().trim().length >= 2
      || this.productFilters.ActiveIngredient !== null && this.productFilters.ActiveIngredient !== '' && this.productFilters.ActiveIngredient.toString().trim().length >= 2
      || this.productFilters.Brand !== null && this.productFilters.Brand !== '' && this.productFilters.Brand.toString().trim().length >= 2
      || this.productFilters.Gtin !== null && this.productFilters.Gtin !== '' && this.productFilters.Gtin.toString().trim().length >= 2
    ) {
      this.disableFilterBtn = false;
    }
    else {
      this.disableFilterBtn = true;
    }    
  }
  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    if (this.filterValueList) {
      const selectedIds = '';

      switch (type) {
        case 'PackageSize':
          this.filter.packageSize = selectedIds;
          break;
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
        case 'ProductLine':
          this.filter.productLine = selectedIds;
          this.filter.productLineDescription = selectedIds;
          break;
        case 'ProductCatogory':
          this.filter.productCategory = selectedIds;
          this.filter.productCategoryDescription = selectedIds;
          break;
        case 'ActiveIngredient':
          this.filter.activeIngredient = selectedIds;
          break;
        case 'Vendor':
          this.filter.vendor = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.Brand && this.productFilters.Brand != '') {
          this.productFilters.Brand = this.productFilters.Brand.trim();
          this.filterValueList.push('Product Name : ' + this.productFilters.Brand);
          this.filter.productName = this.productFilters.Brand;
        }
        else {
          this.filter.productName = null;
        }

        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          let strINO = '';
          this.productFilters.ItemNo.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strINO.substr(0, strINO.length - 2));
          this.filter.itemNo = strINO.substr(0, strINO.length - 2);
        }

        if (this.productFilters.PackageSize && this.productFilters.PackageSize != '') {
          this.productFilters.PackageSize = this.productFilters.PackageSize.trim();
          this.filterValueList.push('Package Size : ' + this.productFilters.PackageSize);
          this.filter.packageSize = this.productFilters.PackageSize;
        }
        else {
          this.filter.packageSize = null;
        }

        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          let strPLValue = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
            const productLine = this.productLineMasterList.find(y => y.id == x);
            if (productLine != undefined) {
              strPLValue = strPLValue + productLine.value + ', ';
            }
          });
          this.filterValueList.push('Product Line : ' + strPLValue.substr(0, strPLValue.length - 2));
          this.filter.productLine = this.productFilters.ProductLineList;
          this.filter.productLine = strPL.substr(0, strPL.length - 2);
          this.filter.productLineDescription = strPLValue.substr(0, strPLValue.length - 2);
        }
        else {
          this.filter.productLine = null;
          this.filter.productLineDescription = null;
        }

        // ActiveIngredient
        if (!this.isFromCOIPage) {
          if (this.productFilters.ActiveIngredient && this.productFilters.ActiveIngredient.length > 0) {
            let strAI = '';
            this.productFilters.ActiveIngredient.forEach(x => {
              strAI = strAI + x + '; ';
            });
            this.filterValueList.push('Active Ingredient : ' + strAI.substr(0, strAI.length - 2));
            this.filter.activeIngredient = strAI.substr(0, strAI.length - 2);
          }
          else {
            this.filter.activeIngredient = null;
          }
        }
        else {
          if (this.productFilters.ActiveIngredient && this.productFilters.ActiveIngredient != '') {
            this.productFilters.ActiveIngredient = this.productFilters.ActiveIngredient.trim();
            this.filterValueList.push('Active Ingredient : ' + this.productFilters.ActiveIngredient);
            this.filter.activeIngredient = this.productFilters.ActiveIngredient;
          }
          else {
            this.filter.activeIngredient = null;
          }
        }

        // Vendor
        if (!this.isFromCOIPage) {
          if (this.productFilters.Vendor && this.productFilters.Vendor.length > 0) {
            let strVendor = '';
            this.productFilters.Vendor.forEach(x => {
              strVendor = strVendor + x + ', ';
            });
            this.filterValueList.push('Vendor : ' + strVendor.substr(0, strVendor.length - 2));
            this.filter.vendor = strVendor.substr(0, strVendor.length - 2);
          }
          else {
            this.filter.vendor = null;
          }
        }
        else {
          if (this.productFilters.Vendor && this.productFilters.Vendor != '') {
            this.productFilters.Vendor = this.productFilters.Vendor.trim();
            this.filterValueList.push('Vendor : ' + this.productFilters.Vendor);
            this.filter.vendor = this.productFilters.Vendor;
          }
          else {
            this.filter.vendor = null;
          }
        }

        // Gtin
        if (this.productFilters.Gtin && this.productFilters.Gtin != '') {
          this.productFilters.Gtin = this.productFilters.Gtin.trim();
          this.filterValueList.push('Gtin : ' + this.productFilters.Gtin);
          this.filter.gtin = this.productFilters.Gtin;
        }
        else {
          this.filter.gtin = null;
        }

        if (this.productFilters.productCategoryList && this.productFilters.productCategoryList.length > 0) {
          let strPL = '';
          let strPLValue = '';
          this.productFilters.productCategoryList.forEach(x => {
            strPL = strPL + x + ', ';
            const productCategory = this.productCategoryMasterList.find(y => y.id == x);
            if (productCategory != undefined) {
              strPLValue = strPLValue + productCategory.value + ', ';
            }
          });
          this.filterValueList.push('Product Category : ' + strPLValue.substr(0, strPLValue.length - 2));
          this.filter.productCategory = this.productFilters.productCategoryList;
          this.filter.productCategory = strPL.substr(0, strPL.length - 2);
          this.filter.productCategoryDescription = strPLValue.substr(0, strPLValue.length - 2);
        }
        else {
          this.filter.productCategory = null;
          this.filter.productCategoryDescription = null;
        }
      }
    }
    if (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
      (this.productFilters.Vendor && this.productFilters.Vendor.length > 0 && this.productFilters.Vendor !== '') ||
      (this.productFilters.Gtin != null && this.productFilters.Gtin !== '') ||
      (this.productFilters.ActiveIngredient && this.productFilters.ActiveIngredient.length > 0 && this.productFilters.ActiveIngredient !== '') ||
      (this.productFilters.PackageSize && this.productFilters.PackageSize !== '') ||
      (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) ||
      (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) ||
      (this.productFilters.productCategoryList && this.productFilters.productCategoryList.length > 0)) {
    }
    this.enableDisableSearchButton();
    this.searchValue = '';
  }
  // Remove all chip filters
  removeAllFilter() {
    if (this.filterValueList.length > 0) {
      this.filterValueList = new Array();
      this.resetFilterInputValue();
      this.enableDisableSearchButton();
      this.filter.clearAll = true;
      this.SearchFilter.emit(this.filter);
      this.productFilters.showFavoriteOnly = false;
      this.favoriteProductsCheck(this.productFilters.showFavoriteOnly);
    }
  }
  // Clear a selected filter value
  clearFilter(filterValue: string) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      this.removeCPPFilter(filterValue);
      this.enableDisableSearchButton();

      if (this.filterValueList.length < 1 && !this.showOnlyFavorite) {
        this.ClearFilter.emit(this.filter);
      }
    }
    // this.onSearchFilter.emit(this.filter);
  }

  // Search button event
  onFilter() {
    this.retainFilter(null, ' ');
    this.SearchFilter.emit(this.filter);
  }

  onTabChange(isShowFavorite) {
    this.filter.showFavoriteOnly = isShowFavorite;
    this.showOnlyFavorite = isShowFavorite;
    if (this.filterValueList.length > 0) {
      this.SearchFilter.emit(this.filter);
    }
  }

  // to validate filter
  validateFilter(productFilter) {
    let isValid = false;

    // To Validate Brand(Product)
    if (productFilter.Brand !== null && productFilter.Brand !== '') {
      isValid = true;
    }

    // // To Validate PackageSize
    if (productFilter.PackageSize != null && productFilter.PackageSize !== '') {
      isValid = true;
    }

    // To Validate ProductLineList
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }

    // To Validate ItemNumber
    if (productFilter.ItemNo != null && productFilter.ItemNo.length > 0) {
      isValid = true;
    }

    // To Validate ProductLineList
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }

    // To Validate ActiveIngredient
    if (productFilter.ActiveIngredient !== null && productFilter.ActiveIngredient !== '') {
      isValid = true;
    }

    // To Validate Vendor
    if (productFilter.Vendor !== null && productFilter.Vendor !== '') {
      isValid = true;
    }
    // To Validate Gtin
    if (productFilter.Gtin !== null && productFilter.Gtin !== '') {
      isValid = true;
    }

    // To Validate Product Category
    if (productFilter.productCategoryList != null && productFilter.productCategoryList.length > 0) {
      isValid = true;
    }

    if (productFilter.Brand == null
      && productFilter.ActiveIngredient == null
      && productFilter.Vendor == null
      && productFilter.Gtin == null
      && (productFilter.ItemNo == null || productFilter.ItemNo.length <= 0)
      && (productFilter.PackageSize == null)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.productCategoryList == null || productFilter.productCategoryList.length <= 0)
    ) {
      isValid = false;
    }
    return isValid;
  }

  // Enable Disable Search
  enableDisableSearchButton() {
    if (this.validateFilter(this.productFilters) || this.showOnlyFavorite) {
      this.disableFilterBtn = false;
    }
    else {
      this.disableFilterBtn = true;
    }
  }
  // Emit event if show favorite check box is checked
  favoriteProductsCheck(isChecked: boolean) {
    this.showOnlyFavorite = isChecked;
    this.filter.showFavoriteOnly = isChecked;
    if (this.filterValueList.length < 1 && !this.showOnlyFavorite) {
      this.ClearFilter.emit();
    }
    this.enableDisableSearchButton();
  }

  // Remove a selected chip search filter
  removeCPPFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;
      // case 'Item Id':
      //  this.productFilters.ItemId = null;
      //  this.filter.itemId = null;
      //  break;
      case 'Product Name':
        this.productFilters.Brand = null;
        this.filter.productName = null;
        break;
      case 'Gtin':
        this.productFilters.Gtin = null;
        this.filter.gtin = null;
        break;
      case 'Package Size':
        this.productFilters.PackageSize = null;
        this.filter.packageSize = null;
        break;
      case 'Vendor':
        this.productFilters.Vendor = null;
        this.filter.vendor = null;
        break;
      case 'Active Ingredient':
        this.productFilters.ActiveIngredient = null;
        this.filter.activeIngredient = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = null;
        this.filter.productLine = null;
        this.filter.productLineDescription = null;
        break;
      case 'Product Category':
        this.productFilters.ProductLineList = null;
        this.filter.productCategory = null;
        this.filter.productCategoryDescription = null;
        break;
      default:
        break;
    }
  }
  // Re initialise the Filters
  resetFilterInputValue() {
    this.productFilters = {
      'ItemNo': [],
      // 'ItemId': [],
      'Brand': null,
      'PackageSize': null,
      'ActiveIngredient': null,
      'Vendor': null,
      'clearAll': false,
      'showFavoriteOnly': false,
      'Gtin': null,
      'ProductLineList': [],
      'productCategoryList': []
    };

    this.filter = {
      'itemNo': null,
      'productName': null,
      'packageSize': null,
      'activeIngredient': null,
      'vendor': null,
      'clearAll': false,
      'showFavoriteOnly': false,
      'gtin': null,
      'productLine': null,
      'shipToOrDeliverToAccount': 0,
      'productCategory': null,
      'productCategoryDescription': null,
      'productLineDescription': null
    };
  }
  // Page destroy event
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
